exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-primary[data-v-dde18c3a]:disabled {\n  cursor: no-drop;\n}\n", ""]);

// exports
